import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Person } from './person';
import { Vehicle } from './vehicle';

@inheritSerialization(Person)
export class Driver extends Person {
  @autoserialize
  dotsDriverIdentifier: number;

  @autoserializeAs(Vehicle)
  vehicles: Array<Vehicle>;
}
